import React, { ComponentProps } from 'react';

import Button from '@adsk/alloy-react-button';
import { useLocale } from '@adsk/alloy-react-locale';
import { useTheme } from '@adsk/alloy-react-styles';

const ClearButton = ({
  variant = Button.VARIANTS.TERTIARY,
  size = Button.SIZES.SMALL,
  onClick,
  style,
  ...props
}: ComponentProps<typeof Button>) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));
  const { tokens } = useTheme();
  const clearButtonTokens = tokens?.component?.footer?.clearButton;

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      style={[clearButtonTokens?._, style]}
      {...props}
    >
      {T.translate('CLEAR')}
    </Button>
  );
};

ClearButton.displayName = 'ClearButton';

export default ClearButton;
